//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.api

import com.tixforgigs.apax.models.ApiError
import com.tixforgigs.apax.models.Order
import com.tixforgigs.apax.models.OrderApproveRequest
import com.tixforgigs.apax.models.OrderRequest
import com.tixforgigs.apax.models.OrderResponse
import com.tixforgigs.apax.models.OrderRestartRequest

import com.tixforgigs.apax.infrastructure.*
import io.ktor.client.HttpClient
import io.ktor.client.HttpClientConfig
import io.ktor.client.request.forms.formData
import io.ktor.client.engine.HttpClientEngine
import kotlinx.serialization.json.Json
import io.ktor.http.ParametersBuilder
import kotlinx.serialization.*
import kotlinx.serialization.descriptors.*
import kotlinx.serialization.encoding.*

open class CommonOrdersApi : ApiClient {

    constructor(
        baseUrl: String = ApiClient.BASE_URL,
        httpClientEngine: HttpClientEngine? = null,
        httpClientConfig: ((HttpClientConfig<*>) -> Unit)? = null,
        jsonSerializer: Json = ApiClient.JSON_DEFAULT
    ) : super(baseUrl = baseUrl, httpClientEngine = httpClientEngine, httpClientConfig = httpClientConfig, jsonBlock = jsonSerializer)

    constructor(
        baseUrl: String,
        httpClient: HttpClient
    ): super(baseUrl = baseUrl, httpClient = httpClient)

    /**
     * Approve order session with id. - BETA (version from:4.6 to:latest)
     * -
     * @param orderId The order id
     * @param orderToken 
     * @param orderApproveRequest 
     * @return OrderResponse
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun orderApprove(orderId: kotlin.Int, orderToken: kotlin.String, orderApproveRequest: OrderApproveRequest): HttpResponse<OrderResponse> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = orderApproveRequest

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.POST,
            "/orders/{orderId}/{orderToken}/approve".replace("{" + "orderId" + "}", "$orderId").replace("{" + "orderToken" + "}", "$orderToken"),
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return jsonRequest(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }



    /**
     * Get an order by its orderId - BETA (version from:4.6 to:latest)
     * -
     * @param orderId 
     * @param orderToken  (optional)
     * @return Order
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun orderDetails(orderId: kotlin.Int, orderToken: kotlin.String? = null): HttpResponse<Order> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = 
            io.ktor.client.utils.EmptyContent

        val localVariableQuery = mutableMapOf<String, List<String>>()
        orderToken?.apply { localVariableQuery["orderToken"] = listOf("$orderToken") }
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.GET,
            "/orders/{orderId}".replace("{" + "orderId" + "}", "$orderId"),
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return request(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }


    /**
     * Get an invoice by id. (version from:4.6 to:latest)
     * 
     * @param orderId 
     * @param invoiceId 
     * @param orderToken  (optional)
     * @return com.tixforgigs.apax.infrastructure.Base64ByteArray
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun orderInvoice(orderId: kotlin.Int, invoiceId: kotlin.Int, orderToken: kotlin.String? = null): HttpResponse<com.tixforgigs.apax.infrastructure.Base64ByteArray> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = 
            io.ktor.client.utils.EmptyContent

        val localVariableQuery = mutableMapOf<String, List<String>>()
        orderToken?.apply { localVariableQuery["orderToken"] = listOf("$orderToken") }
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.GET,
            "/orders/{orderId}/invoice/{invoiceId}".replace("{" + "orderId" + "}", "$orderId").replace("{" + "invoiceId" + "}", "$invoiceId"),
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return request(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }


    /**
     * Restart order session with id. - BETA (version from:4.6 to:latest)
     * -
     * @param orderId The order id
     * @param orderToken 
     * @param orderRestartRequest 
     * @return OrderResponse
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun orderRestart(orderId: kotlin.Int, orderToken: kotlin.String, orderRestartRequest: OrderRestartRequest): HttpResponse<OrderResponse> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = orderRestartRequest

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.POST,
            "/orders/{orderId}/{orderToken}/restart".replace("{" + "orderId" + "}", "$orderId").replace("{" + "orderToken" + "}", "$orderToken"),
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return jsonRequest(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }



    /**
     * Submit the order - BETA (version from:4.6 to:latest)
     * -
     * @param orderRequest 
     * @return OrderResponse
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun orderSubmit(orderRequest: OrderRequest): HttpResponse<OrderResponse> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = orderRequest

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.POST,
            "/orders",
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return jsonRequest(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }



    /**
     * Get all orders - BETA (version from:4.6 to:latest)
     * -
     * @param dbVersion Defines a db version to sync only a diff since this version. (optional, default to 0L)
     * @param details If details set to true, we send event data with products, resales,... if false, only data relevant for lists will be sent (optional)
     * @param page Zero-based page index (0..N) (optional, default to 0)
     * @param size The size of the page to be returned (optional, default to 24)
     * @param sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. (optional)
     * @return kotlin.collections.List<Order>
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun ordersAll(dbVersion: kotlin.Long? = 0L, details: kotlin.Boolean? = null, page: kotlin.Int? = 0, size: kotlin.Int? = 24, sort: kotlin.collections.List<kotlin.String>? = null): HttpResponse<kotlin.collections.List<Order>> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = 
            io.ktor.client.utils.EmptyContent

        val localVariableQuery = mutableMapOf<String, List<String>>()
        dbVersion?.apply { localVariableQuery["dbVersion"] = listOf("$dbVersion") }
        details?.apply { localVariableQuery["details"] = listOf("$details") }
        page?.apply { localVariableQuery["page"] = listOf("$page") }
        size?.apply { localVariableQuery["size"] = listOf("$size") }
        sort?.apply { localVariableQuery["sort"] = toMultiValue(this, "multi") }
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.GET,
            "/orders",
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return request(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap<OrdersAllResponse>().map { value }
    }

    @Serializable(OrdersAllResponse.Companion::class)
    private class OrdersAllResponse(val value: List<Order>) {
        companion object : KSerializer<OrdersAllResponse> {
            private val serializer: KSerializer<List<Order>> = serializer<List<Order>>()
            override val descriptor = serializer.descriptor
            override fun serialize(encoder: Encoder, value: OrdersAllResponse) = serializer.serialize(encoder, value.value)
            override fun deserialize(decoder: Decoder) = OrdersAllResponse(serializer.deserialize(decoder))
        }
    }

}
